module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAIVBMVEUAAAD////zwszjbYXWKkzZPVzQDDP54ebsnq3cSWb2ztYLMiGeAAAAAXRSTlMAQObYZgAAAEpJREFUeAFjwASMgmAgAGQouxiBGUJhaamKIIZwWlqaIYghAmQ4Ahls6UClZWkJDGwZQEYbiJG5UFBqGoiRNqO8Mw3MAAIUBm4AAFxDFTC97BuNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/GL.png
// module id = 1149
// module chunks = 0